<template>
  <div class="broker-terms-of-service">
    <div class="text-container">
      <div class="row">
        <h1>
          Broker Terms of Service
        </h1>
      </div>
      <div class="content">
        <p><span style="font-size: 18px;">1.&nbsp; &nbsp; &nbsp; &nbsp;Broker Eligibility. If you access the Service as a Broker, in addition to the representations and warranties in Section 3 of the Terms, you represent and warrant to us that, at all times while using the Service as a Broker; (a) you are a licensed charter broker; (b) you have not previously been suspended or prohibited from performing charter brokerage services; and (c) your operations and your use of the Service are in compliance with all applicable laws, regulations, required to perform charter brokerage services. You must immediately notify SharedCharter if you are no longer able to satisfy the foregoing representations. When you are registering for a Broker account, you will be required to provide us with certain information to demonstrate your qualifications.</span></p>
        <p><span style="font-size: 18px;">2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Flight Transactions. Subject to Section 4.2 of the Terms, a Broker may enter into a Flight Transaction with an Operator only if another User of the Service enters into such Flight Transaction.</span></p>
        <p><span style="font-size: 18px;">3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; User-Operator Payments. If you are a Broker who enters into a Flight Transaction with a Passenger or an Operator, then you may be entitled to a commission from the Operator. SharedCharter will have no responsibility to you for commission payments owed to you by Operators in connection with a Flight Transaction.</span></p>
        <p><span style="font-size: 18px;">4.&nbsp; &nbsp; &nbsp;Brokers are welcome to list flights in the SharedCharter Database (SCD) if they are flights for which the broker has a client willing to share such flight.</span></p>
        <p><span style="font-size: 18px;">If a Sharer is paired by use of the SCD, then the broker agrees to enter into an agreement to pay SharedCharter a fee for this pairing.</span></p>
        <p><span style="font-size: 18px;">In the same way, Brokers are welcome to search the SCD in order to find any flights that may fit a client the Broker has or will get for sharing. If a pairing is found, the Broker agrees to enter into an agreement to pay SharedCharter a fee for such pairing.</span></p>          
      </div>
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style scoped>

li {
  margin-left: 1em;
}

ol {
  margin-top: 0;
  margin-bottom: 1rem;
}

ul.dotted-list {
  list-style: revert;
}

.text-container {
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
  width: 80%;
  padding: 2% 0%;
}

.content {
  margin-top: 4%;
  margin-left: -15px;
  margin-right: -15px;
}

</style>